import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { breakpoints, golf } from './enums';
import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';
import { IntlProvider } from 'react-intl';
import Icon from '@ux/icon';
import WaffleMenu from './waffle';

/**
 * Render Big Three product dropdown.
 *
 * @Constructor
 * @class BigThree
 * @api public
 */
class AppName extends NamespaceConsumer {
  /**
   * Add eventListeners for breakpoints.
   *
   * @api private
   */
  componentDidMount() {
    this.breakpoint(...breakpoints);
  }

  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */
  componentWillUnmount() {
    this.breakup();
  }

  render() {
    const { market, messages, showWaffleMenu, app, appName, waffleVariant } = this.props;

    let appNameOverride = messages[golf.home];
    if (['B', 'C', 'D'].indexOf(waffleVariant) !== -1) {
      appNameOverride = messages[golf.myAccount];
    }
    const name = (['riviera', 'mya', 'go', 'account', 'sso'].indexOf(app) >= 0) ?
      appNameOverride : appName;
    const productName = <span className={ this.namespace('product-name') }>{ name }</span>;
    let content = productName;

    if (showWaffleMenu) {
      const control = (
        <Fragment>
          <Icon name='apps'/>
          { productName }
        </Fragment>
      );
      content = <WaffleMenu { ...this.props } control={ control } />;
    }

    return (
      <IntlProvider locale={ market } messages={ messages }>
        { content }
      </IntlProvider>
    );
  }
}

AppName.propTypes = {
  ...NamespaceShape,
  urls: PropTypes.object.isRequired,
  app: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
  market: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  showWaffleMenu: PropTypes.bool
};

export default withNamespace(AppName);
